import React from 'react';
import { Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import industry from 'assets/impact-report/indus-min.jpeg';
import co2 from 'assets/impact-report/co2.png';
import egrid from 'assets/impact-report/egrid-min.jpeg';

// Create styles
const styles = StyleSheet.create({
  section4: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    height: 200,
    position: 'relative',
    // backgroundColor: '#ccc',
  },
  section4CenterLeft: {
    // backgroundColor: '#ccc',
    width: '100%',
    height: 400,
  },
  section4CenterRight: {
    width: '100%',
    height: 85,
  },
  bottomText: {
    fontSize: 24,
    color: '#FFFCE8',
    fontFamily: 'Trebuchet',
    fontWeight: 'bold',
    textAlign: 'center',
    paddingTop: 50,
  },
  impactTextTitile: {
    fontSize: 12,
  },
  impactTextTitileBtm: {
    fontSize: 8,
  },
  impactTextSubBtm: {
    fontSize: 20,
    fontWeight: 1200,
  },
  impactTextSub: {
    fontSize: 28,
    fontWeight: 1200,
  },
  waste: {
    width: 200,
    height: 200,
    borderRadius: '100%',
    position: 'absolute',
  },
  summary: {
    width: 120,
    height: 120,
    borderRadius: '100%',
  },
  summaryImg: {
    border: '15px solid #FFD100',
    borderRadius: '100%',
    overflow: 'hidden',
    position: 'absolute',
  },
  summaryImgLeft: {
    left: -25,
    top: -25,
  },
  summaryImgRight: {
    right: -25,
    top: -25,
  },
  summaryImgBtm: {
    bottom: '-97%',
    left: 30,
  },
  summaryBtmEgrid: {
    width: 86,
    height: 86,
    borderRadius: '100%',
    overflow: 'hidden',
  },
  summaryRectangle: {
    width: '80%',
    backgroundColor: '#53575A',
    height: 100,
    margin: 'auto',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    textAlign: 'center',
    textTransform: 'uppercase',
    gap: 15,
  },
  summaryBtmTxt: {
    position: 'absolute',
    top: '130%',
    left: 160,
    color: '#53575A',
    fontFamily: 'Trebuchet',
    fontWeight: 'bold',
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    textTransform: 'uppercase',
    width: 300,
  },
  centerRightTextBtm: {
    color: '#fff',
    fontFamily: 'Trebuchet',
    fontWeight: 'bold',
    width: 100,
  },
});

type PdfImpactReportProps = {
  reportData: any;
};

const ImpactSection2 = ({ reportData }: PdfImpactReportProps) => {
  const reportImpact = reportData.impact;

  return (
    <>
      <View style={styles.section4}>
        <View style={styles.section4CenterLeft}>
          <View style={{ ...styles.summaryRectangle }}>
            <View
              style={{
                ...styles.centerRightTextBtm,
                textAlign: 'left',
                paddingLeft: 20,
              }}>
              <View>
                <Text style={styles.impactTextTitileBtm}>Pounds of</Text>
              </View>
              <View>
                <Text style={styles.impactTextTitileBtm}>co2 mitigated:</Text>
              </View>
              <View>
                <Text style={styles.impactTextSubBtm}>
                  {reportImpact?.co2m?.toLocaleString() || '0'}
                </Text>
              </View>
            </View>
            <View
              style={{
                ...styles.centerRightTextBtm,
                textAlign: 'right',
                paddingRight: 20,
              }}>
              <View>
                <Text style={styles.impactTextTitileBtm}>liters of</Text>
              </View>
              <View>
                <Text style={styles.impactTextTitileBtm}>crude oil saved:</Text>
              </View>
              <View>
                <Text style={styles.impactTextSubBtm}>
                  {reportImpact?.cos?.toLocaleString() || '0'}
                </Text>
              </View>
            </View>
            <View style={{ ...styles.summaryImg, ...styles.summaryImgLeft }}>
              <Image style={{ ...styles.summary }} src={co2} />
            </View>
            <View style={{ ...styles.summaryImg, ...styles.summaryImgRight }}>
              <Image style={{ ...styles.summary }} src={industry} />
            </View>
            <View style={{ ...styles.summaryImg, ...styles.summaryImgBtm }}>
              <Image style={{ ...styles.summaryBtmEgrid }} src={egrid} />
            </View>
            <View style={styles.summaryBtmTxt}>
              <View style={{ marginLeft: '-10px' }}>
                <Text style={styles.impactTextSub}>
                  {reportImpact?.er?.toLocaleString() || '0'}
                </Text>
              </View>
              <View>
                <View>
                  <Text style={styles.impactTextTitile}>kwh of</Text>
                </View>
                <View>
                  <Text style={styles.impactTextTitile}>energy reduced</Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      </View>
    </>
  );
};

export default ImpactSection2;
